module.exports = __webpack_public_path__ + "img/40_38_068_440.8c9fa34d.jpg";